module.exports = __webpack_public_path__ + "img/blue-penguin.872f8c23.svg";